import JSEncrypt from "jsencrypt/bin/jsencrypt.min";

// 密钥对生成 http://web.chacuo.net/netrsakeypair

const publicKey =
  "MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAJLFuYZFHge3wdplyhjTSbNgvVJsjCT5FS7QmvdEPgTq10J6RqxKU8CMMLP/VG0bQnQi3UlqP3J3B69ZbxZqRlcCAwEAAQ==";

const privateKey =
  "MIIBVAIBADANBgkqhkiG9w0BAQEFAASCAT4wggE6AgEAAkEAqhHyZfSsYourNxaY\n" +
  "7Nt+PrgrxkiA50efORdI5U5lsW79MmFnusUA355oaSXcLhu5xxB38SMSyP2KvuKN\n" +
  "PuH3owIDAQABAkAfoiLyL+Z4lf4Myxk6xUDgLaWGximj20CUf+5BKKnlrK+Ed8gA\n" +
  "kM0HqoTt2UZwA5E2MzS4EI2gjfQhz5X28uqxAiEA3wNFxfrCZlSZHb0gn2zDpWow\n" +
  "cSxQAgiCstxGUoOqlW8CIQDDOerGKH5OmCJ4Z21v+F25WaHYPxCFMvwxpcw99Ecv\n" +
  "DQIgIdhDTIqD2jfYjPTY8Jj3EDGPbH2HHuffvflECt3Ek60CIQCFRlCkHpi7hthh\n" +
  "YhovyloRYsM+IS9h/0BzlEAuO0ktMQIgSPT3aFAgJYwKpqRYKlLDVcflZFCKY7u3\n" +
  "UP8iWi1Qw0Y=";

// 加密
export function encrypt(txt) {
  const encryptor = new JSEncrypt();
  encryptor.setPublicKey(publicKey); // 设置公钥
  return encryptor.encrypt(txt); // 对数据进行加密
}

// 解密
export function decrypt(txt) {
  const encryptor = new JSEncrypt();
  encryptor.setPrivateKey(privateKey); // 设置私钥
  return encryptor.decrypt(txt); // 对数据进行解密
}

/**
 * 非对称加密
 * @param {String}  需要加密的参数
 */
export function rsaEncryption(param) {
  // 后台给的公钥
  // TODO GuoFu: 2022/4/30 可优化为从后台获取
  let publicKey =
    "MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAJLFuYZFHge3wdplyhjTSbNgvVJsjCT5FS7QmvdEPgTq10J6RqxKU8CMMLP/VG0bQnQi3UlqP3J3B69ZbxZqRlcCAwEAAQ==";
  let encryptor = new JSEncrypt(); // 新建JSEncrypt对象
  encryptor.setPublicKey(publicKey); // 设置公钥
  let passwordEncryp = encryptor.encrypt(param); // 对数据进行加密
  return passwordEncryp;
}

/**
 * 非对称解密
 * @param param:String , 需要加密的参数
 * @param publicKey:String,  解密私钥
 */
export function rsaDecrypt(param, publicKey) {
  const encryptor = new JSEncrypt();
  encryptor.setPrivateKey(publicKey); // 设置私钥
  return encryptor.decrypt(param); // 对数据进行解密
}
